import * as React from 'react';
import SearchIcon from "@mui/icons-material/Search"

import mainTheme from "../Themes";
import { Icon, IconButton, TextField, Typography } from '@mui/material';

interface SearchBarProps {
    searchLabel: string;
    searchPlaceholder: string;
    callbackFunction: any;
}

const SearchBar: React.FC<SearchBarProps> = ({ searchLabel, searchPlaceholder, callbackFunction }) => {
    return (
        <form>
            <TextField
                id="search-bar" 
                className="text" 
                onInput={(e) => {
                    //@ts-expect-error
                    callbackFunction(e.target.value);
                }} 
                label={searchLabel} 
                variant="outlined" 
                placeholder={searchPlaceholder} 
                size="small"
                sx={{ backgroundColor: "#ffffff" }}
            />
                <Icon aria-label="search" sx={{ mt: 0.8, ml: 0.5 }}>
                    <SearchIcon style={{ fill: "gray" }} />
                </Icon>
        </form>
    );
}

export default SearchBar;
